import moment from 'moment';
export const required = value => (value ? undefined : 'required');
export const passwordValidation = password => {
    if (
        !password ||
        password.length < 7 ||
        !/[A-Z]/.test(password) ||
        !/[a-z]/.test(password) ||
        !/\d/.test(password)
    ) {
        return 'invalid'; //Password should have min 7 chars, 1 UpperCase, 1 LowerCase, 1 Number
    } else {
        return undefined;
    }
};

export const emailIsValid = value =>
    value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value) ? 'invalid' : undefined;

export const emailIsValidChars = value => {
    let flag = undefined;
    value &&
        window.VULOG_CONFIG.FORBIDDEN_EMAIL_CHARACTERS.forEach(char => {
            if (value.indexOf(char) !== -1) {
                flag = 'invalid character';
            }
        });
    return flag;
};

export const dateIsValid = date => {
    if (!moment.utc(date).isValid()) {
        return 'invalid';
    }
    return undefined;
};

export const expirationDateIsValid = date => {
    if (!moment.utc(date).isValid()) {
        return 'invalid';
    }

    if (moment.utc(date).isBefore(moment())) {
        return 'expired';
    }
    return undefined;
};

export const expirationDateIsValidOrEmpty = date => {
    if (!date) {
        return undefined;
    }
    return expirationDateIsValid(date);
};
export const passwordMatch = (value, all) => {
    if (all.password !== value) {
        return "doesn't match";
    } else {
        return undefined;
    }
};

export const emailMatch = (value, all) => {
    if (all.email !== value) {
        return 'The Emails entered do not match. Please check that your information is correct';
    } else {
        return undefined;
    }
};

export const passwordStrengthValidation = (strength, minPasswordStrength) => {
    if (strength < minPasswordStrength - 1) {
        return 'Please enter a stronger password (with more letters, numbers, special characters or capital letters)';
    } else {
        return undefined;
    }
};
